
//brand.(id).products.(id)
export const BRAND_PRODUCT_STATUS = {
  active: 'active',
  completed: 'completed'
}
